import BasePopUpLayer from "../../../engines/components/BasePopUpLayer";
import BaseStateSprite from "../../../engines/components/state/BaseStateSprite";
import O1HD from "../../../engines/gameEngine";
import data_control from "../../../engines/libs/data_control";
import utilsModel from "../../../engines/libs/utilsModel";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../normalMode/BundleResourceConfig";
import { backPackEventMap } from "../../normalMode/config/BackpackEventConfig";
import NormalGameManager from "../../normalMode/manager/NormalGameManager";


const {ccclass, property} = cc._decorator;

@ccclass
export default class BravoGetGoodsLayer extends BasePopUpLayer {

    cleanNode:cc.Node = null;

    @property(cc.Node)
    nodeWood: cc.Node = null;

    @property(BaseStateSprite)
    sprResult: BaseStateSprite = null;

    @property({type:cc.Node,displayName:"top节点"})
    topNode:cc.Node = null;

    @property({type:cc.Label,displayName:"描述文本"})
    explainLb:cc.Label = null;

    @property({type:cc.Label,displayName:"名字文本"})
    nameLb:cc.Label = null;

    @property({type:cc.Label,displayName:"估价文本"})
    lbPrice:cc.Label = null;

    @property(cc.Sprite)
    nodeGoods: cc.Sprite = null;

    @property({type:cc.Node,displayName:"光效节点"})
    lightNode:cc.Node = null;

    showNode:cc.Node = null;

    buyCoin:number = 0;
    sellCoin:number = 0;

    start(){
        this.nodeGoods.node.active = false;
        let tween = cc.tween(this.lightNode).by(3,{angle:360}).call(()=>{
            this.lightNode.angle = 0;
        })
        cc.tween(this.lightNode).repeatForever(tween).start();

        this.showGoods(this._carryData.id);
    }

    async showGoods(goodsId: number) {
        if (!goodsId) {
            return;
        }
        this.sprResult.setFill(false);
        this.nodeGoods.node.active = false;
        let backConfig = backPackEventMap()[goodsId];
        this.nameLb.string = backConfig.name;
        this.sellCoin = backConfig.sellPrice;
        this.lbPrice.string = data_control.getNumberFormat(this.sellCoin);
        // 没有事件 按照正常流程结算
        this.setExplain(backConfig.details);

        if(backConfig){
            let objPath:string = backConfig.spPath;
            let iconPath = "backpackAssets/objSp/" + objPath;
            let bundlePb = await getOneBundle( BUNDLE_SMALL_NAME.backPackGameBundle );
            bundlePb.load(iconPath, cc.SpriteFrame
                , (err,imgs:cc.SpriteFrame)=>
                {
                    if(err){
                        console.log(err);
                    }else{
                        this.nodeGoods.node.active = true;
                        this.nodeGoods.spriteFrame = imgs;
                    }
                }
            );
        }
    }
    
    onBtnSell(event: cc.Event.EventTouch){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.doSell(event.target);
    }

    doSell(node: cc.Node, scale: number = 1) {
        let price:number = this.sellCoin * scale;
        O1HD.getServices().userSrv.setCoins(price,true, node);
        this.closeThis();
    }

    onClickDoubleSell(event: cc.Event.EventTouch) {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.doSell(event.target, 2);
        },()=>{

        },null,"获得道具观看视频双倍卖出");
    }

    onClickPushBackpack() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

      
        let goodsId = this._carryData.id;
        NormalGameManager._instance.onPushGoods(goodsId,1);
        let pushBackpackCab = this._carryData.pushBackpackCab;
        pushBackpackCab && pushBackpackCab();
        // O1HD.emit(MessageEventKind.EventName.REFRESH_OilField_COLLECT_STATE);

        this.closeThis();
    }

    async setExplain(str:string){
        this.explainLb.string = "";
        return new Promise<void>(async resolve=>{
            for(let i = 0;i<str.length;i++){
                this.explainLb.string += str[i];
                await new Promise<void>(resolve=>{
                    this.scheduleOnce(resolve,0.02);
                });
            }
            resolve();
        });
    }

    closeThis(){
        let exit = this._carryData.exit;
        exit && exit();
        
        this.cleanNode?.destroy();
        this.cleanNode?.removeFromParent();
        this.node.destroy();
        this.node.removeFromParent();
    }

}
